var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCross(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.3681 2.72399L9.0001 7.35599L13.6081 2.74799C13.7099 2.63965 13.8325 2.55299 13.9686 2.49319C14.1047 2.43339 14.2515 2.40169 14.4001 2.39999C14.7184 2.39999 15.0236 2.52642 15.2486 2.75147C15.4737 2.97651 15.6001 3.28173 15.6001 3.59999C15.6029 3.74712 15.5756 3.89326 15.5199 4.02945C15.4642 4.16565 15.3812 4.28902 15.2761 4.39199L10.6081 8.99999L15.2761 13.668C15.4739 13.8615 15.5898 14.1235 15.6001 14.4C15.6001 14.7183 15.4737 15.0235 15.2486 15.2485C15.0236 15.4736 14.7184 15.6 14.4001 15.6C14.2472 15.6063 14.0946 15.5808 13.952 15.525C13.8095 15.4693 13.6801 15.3844 13.5721 15.276L9.0001 10.644L4.3801 15.264C4.2787 15.3687 4.15758 15.4523 4.0237 15.51C3.88982 15.5677 3.74585 15.5983 3.6001 15.6C3.28184 15.6 2.97661 15.4736 2.75157 15.2485C2.52653 15.0235 2.4001 14.7183 2.4001 14.4C2.3973 14.2529 2.4246 14.1067 2.48031 13.9705C2.53603 13.8343 2.61899 13.711 2.7241 13.608L7.3921 8.99999L2.7241 4.33199C2.52632 4.1385 2.41035 3.87649 2.4001 3.59999C2.4001 3.28173 2.52653 2.97651 2.75157 2.75147C2.97661 2.52642 3.28184 2.39999 3.6001 2.39999C3.8881 2.40359 4.1641 2.51999 4.3681 2.72399Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCross);
export default __webpack_public_path__ + "static/media/cross.3d84e3bf7301c99b3ba583b970972334.svg";
export { ForwardRef as ReactComponent };